var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVela0)",
    d: "m17.357 11.194l-2.143 3.754c-.664 1.158-1.886 1.766-3.214 1.766l3.214-5.516l1.072-1.877z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVela1)",
    d: "m17.357 11.194l-2.143 3.754c-.664 1.158-1.864 1.74-3.193 1.74l3.193-5.49l1.072-1.877z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVela2)",
    d: "m20.571 9.428l-1.071 1.77l-2.143 3.75c-.664 1.158-1.886 1.766-3.214 1.766H12c1.328 0 2.524-.63 3.188-1.787l2.169-3.729l-1.071-1.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVela3)",
    d: "M16.346 9.428H7.714L8.4 8.07l.39-.784h4.324c1.32 0 2.542.801 3.214 2.1l.022.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVela4)",
    d: "M16.346 9.428H7.714l1.14-2.142h4.359c1.32 0 2.46 1.002 3.128 2.142z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVela5)",
    d: "M16.264 9.287c-.664-1.14-1.83-2.001-3.146-2.001H8.833L7.744 9.428L5.571 5.571H12a3.7 3.7 0 0 1 2.254.772l.099.077q.138.118.265.244q.344.348.596.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVela6)",
    d: "M12 16.714H9.857l-2.143-3.643a3.71 3.71 0 0 1 .017-3.677l.373.613l1.753 3.064z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVela7)",
    d: "M12 16.718v-.004H9.857l-2.143-3.643a3.66 3.66 0 0 1 .022-3.651z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedVela8)",
    d: "m12.017 16.714l-2.16 3.857l-2.143-3.75l-1.071-1.873a4 4 0 0 1-.305-.677l-.03-.103a4 4 0 0 1-.137-.625l-.008-.107l-.009-.112v-.013l-.008-.115v-.116a3.8 3.8 0 0 1 .278-1.436l.047-.111q.079-.171.172-.335l1.08-1.778a3.66 3.66 0 0 0-.005 3.651l2.143 3.643z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVela0",
    x1: 27.303,
    x2: 10.454,
    y1: 4.363,
    y2: 24.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D7EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVela1",
    x1: 18.933,
    x2: 11.578,
    y1: 8.111,
    y2: 23.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D7EFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVela2",
    x1: 19.971,
    x2: 3.384,
    y1: 5.227,
    y2: 17.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D7EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVela3",
    x1: 1.983,
    x2: 21.571,
    y1: -0.309,
    y2: 1.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D7EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVela4",
    x1: 5.333,
    x2: 20.11,
    y1: 13.371,
    y2: 13.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D7EFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVela5",
    x1: 6.01,
    x2: 21.584,
    y1: 7.338,
    y2: 9.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D7EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVela6",
    x1: 17.036,
    x2: 13.825,
    y1: 28.027,
    y2: 4.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D7EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVela7",
    x1: 18.209,
    x2: 11.39,
    y1: 21.954,
    y2: 4.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D7EFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedVela8",
    x1: 10.178,
    x2: 7.83,
    y1: 20.503,
    y2: 9.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02F0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D7EFE"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVela);
export default __webpack_public_path__ + "static/media/vela.c1760d70de8ef8d539e1fc3d97cee933.svg";
export { ForwardRef as ReactComponent };